<div class="fullcontainer pr-3">
  <div class='sheet'>
    <div class='titleContainer'>
      <h1 class='header'>Report - Find Invoice by ticket number</h1>
    </div>

    <div class='row'>
      <div class='col-md-4'>
        <label>Ticket Number (one only)</label>
        <input type='text' [(ngModel)]="this.searchFilters.ticketNumber" class='form-control' />
      </div>
    </div>
    <br />
    <br />
    <button class='btn btn-primary' (click)='this.loadReport()'>Run Report</button>
    <hr />
    <!-- <button class='btn btn-secondary' (click)='exportToCSV()'>Export to CSV</button> -->
  </div>

  <div class='sheet'>
    @if (this.results.length > 0) {
      <div class='titleContainer'>
        <h1 class='header'>{{ this.results.length }} Results found</h1>
        <table class='table'>
          <thead>
            <th>Order</th>
            <th>Job</th>
            <th>Job Date</th>
            <th>Customer</th>
            <th>Site</th>
            <th>Tip Site</th>
            <th>Tickets</th>
            <th>Invoice</th>
            <th>Vehicle Reg</th>
          </thead>
          <tbody>
            @for (result of this.results; track result) {
              <tr>
                <td><button class='btn btn-warning' [routerLink]='"/job-signoff/land/view/"+ result.jobId +"/manager"'>View Job: {{ result.jobId }}</button></td>
                <td><button class='btn btn-warning' [routerLink]='"/orders/edit/" + result.orderId'>View Order: {{ result.orderId }}</button></td>
                <td>{{ result.jobDate }}</td>
                <td>{{ result.accountName }}</td>
                <td>{{ result.siteName }}</td>
                <td>{{ result.tipSiteName }}</td>
                <td>{{ result.tickets }}</td>
                <td><button class='btn btn-warning' [routerLink]='"/invoices/edit/" + result.invoiceId'>View Invoice: {{ result.invoiceId }}</button>
                <button class='btn btn-primary' (click)='this.createPDFFile(result.invoiceId)'>Print Invoice: {{ result.invoiceId }}</button></td>
                <td>{{ result.registration }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
